import { io } from "socket.io-client";
import { apiSlice } from "../api/apiSlice";

export const messagesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMessages: builder.query({
            query: (id) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            transformResponse: (res, meta) => {
                const totalCount = meta.response.headers.get("X-Total-Count");
                return {
                    messages: res,
                    totalCount,
                };
            },
            onCacheEntryAdded: async (arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
                // create socket
                const socket = io(process.env.REACT_APP_API_URL, {
                    reconnectionDelay: 1000,
                    reconnection: true,
                    reconnectionAttemps: 10,
                    transports: ["websocket"],
                    agent: false,
                    upgrade: false,
                    rejectUnauthorized: false,
                });

                try {
                    await cacheDataLoaded;
                    socket.on(`message-${arg}`, (data) => {
                        updateCachedData(draft => {
                            // eslint-disable-next-line
                            const msg = draft.messages.find(msg => msg.id == data.data.id);
                            if (msg) {
                                console.log("duplicate"); return;
                            }
                            draft.messages.push(data.data);
                            draft.totalCount = Number(draft.totalCount) + 1;
                        })
                    })
                } catch (err) {
                    console.log(err);
                }
                await cacheEntryRemoved;
                socket.close();
            }
        }),
        getMoreMessages: builder.query({
            query: ({ id, page }) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            onQueryStarted: async ({ id, page }, { queryFulfilled, dispatch }) => {
                try {
                    const messages = await queryFulfilled;
                    if (messages?.data?.length > 0) {
                        dispatch(apiSlice.util.updateQueryData("getMessages", id, draft => {
                            draft.messages = [...messages.data, ...draft.messages]
                            console.log(JSON.stringify(draft), messages);
                            // draft.messages.push(messages.data);
                        }))
                    }
                } catch (error) {

                }
            }
        }),
        addMessage: builder.mutation({
            query: (data) => ({
                url: "/messages",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
